/**
 * ss-blog-carousel.js — Horizontal blog slider
 */
(function () {
  'use strict';

  function init(section) {
    if (!section || section.dataset.ssBlogInit) return;
    section.dataset.ssBlogInit = '1';

    var track = section.querySelector('[data-ss-blog-track]');
    var prev = section.querySelector('[data-ss-blog-prev]');
    var next = section.querySelector('[data-ss-blog-next]');
    if (!track) return;

    function scrollBy(dir) {
      var amount = track.clientWidth || 320;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ss-blog-carousel]').forEach(init);
  });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ss-blog-carousel]').forEach(init);
  });
})();
